import { render } from "./XiangQingIndex.vue?vue&type=template&id=461d34b7&scoped=true"
import script from "./XiangQingIndex.vue?vue&type=script&lang=js"
export * from "./XiangQingIndex.vue?vue&type=script&lang=js"

import "./XiangQingIndex.vue?vue&type=style&index=0&id=461d34b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461d34b7"]])

export default __exports__